import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import Grid from '@mui/material/Grid';
// import {HttpStatusCode} from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getFormSyncWarnings, getFormValues, reduxForm} from 'redux-form';
// import {getComboName} from '../../../../common/common.js';
// import {getSessionObject, setSessionObject} from '../../../../common/Session.js';
import {getSessionObject} from '../../../../common/Session.js';
// import {postRequest,
// putRequest
// } from '../../../../../common/backend.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {createFieldItems, createGridFields, sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
// import PageTitle from '../../../../molecules/PageTitle.js';
// import FooterButton from '../../../organisms/FooterButton.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import Approval from '../../../molecules/Approval.js';
// import CustomBreadcrumbs from '../../../../molecules/Breadcrumbs.js';
import {AutoComplete} from '@grapecity/wijmo.input';
import {DataMap} from '@grapecity/wijmo.grid';
// import Typography from '@mui/material/Typography';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import DangerButton from '../../../atoms/Buttons/DangerButton.js';
// import NegativeButton from '../../../../atoms/Buttons/NegativeButton.js';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import GetAppIcon from '@mui/icons-material/GetApp';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import CustomerSelect from '../../SCZ/SCZ1012';
import withFormatMessage from '../../../organisms/withFormatMessage.js';
import {withMediaQuery} from '../../../atoms/withMediaQuery.js';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';

// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.ZENSITETU_LIST.name,
    href: GMN_PATH.ZENSITETU_LIST},
  {gmnName: GMN.ZENSITETU_INFO.name, href: ''},
];

// 申請情報Items
const gmnItemsNyuryo = {
  SinseiId: {binding: 'sinseiId', label: '申請番号', required: false, type: 'text', sm: 2, readOnly: true},
  Zigyoujo: {binding: 'zigyoujo', label: 'NW事業所', required: false, type: 'text', sm: 2, readOnly: true},
  userName: {binding: 'userName', label: '作成者', required: false, type: 'text', sm: 2, readOnly: true},
  SakuseiDate: {binding: 'sakuseiDate', label: '作成日', required: false, type: 'text', sm: 2, readOnly: true},
  States: {binding: 'states', label: 'ステータス', required: false, type: 'text', sm: 2, readOnly: true},
};

// 承認ステータスItems
const gmnItemsStepApproval = {
  StepApprovalComment: {binding: 'stepApprovalComment', label: '否決コメント', required: false, type: 'text', sm: 6, variant: 'outlined', multiline: true, rows: 3, readOnly: true},
  StepApprovalDateTime: {binding: 'stepApprovalDateTime', label: '否決日', required: false, type: 'text', sm: 2, readOnly: true},
};

// 毎年調査お客さま全使撤リスト
const henkomaeViews = [
  {binding: 'hikitudukiSaki', header: '引き継ぎ', text: '引き継ぎ', dataType: 'cellMaker', required: false, width: 100, click: null, isReadOnly: true},
  {binding: 'haisiFlag', header: '廃止', required: false, dataType: 'Boolean', width: 80, sm: 3, readOnly: false},
  // {binding: 'haisiFlag', header: '廃止', required: false, dataType: 'Select', width: 80, sm: 3, readOnly: false},
  {header: '全使撤リスト', dataType: 'header', elems: [
    {binding: 'kukakuBango', header: 'ブロック番号', required: false, dataType: 'String', width: 130, readOnly: true},
    {binding: 'supplyPointNo', header: '供給地点特定番号', required: false, dataType: 'String', width: 220, readOnly: true},
    {binding: 'customerName', header: 'お客さま名', required: false, dataType: 'String', width: 200, readOnly: true},
    {binding: 'hijikaCode', header: '調査管理区分', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
    {binding: 'chousaGyousyu', header: '調査業種', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
    {binding: 'bikou', header: '備考', required: false, dataType: 'String', width: 300, readOnly: false},

  ]},
  {header: '引き継ぎ', dataType: 'header', elems: [
    {binding: 'kukakuBangoHk', header: 'ブロック番号', required: false, dataType: 'String', width: 130, readOnly: true},
    {binding: 'supplyPointNoHk', header: '供給地点特定番号', required: false, dataType: 'String', width: 220, readOnly: true},
    {binding: 'customerNameHk', header: 'お客さま名', required: false, dataType: 'String', width: 200, readOnly: true},
    {binding: 'hijikaCodeHk', header: '調査管理区分', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},
    {binding: 'chousaGyousyuHk', header: '調査業種', required: false, dataType: 'String', width: 200, sm: 3, readOnly: true},

  ]},

];

/**
 * 毎年調査お客さま全使撤リスト
 * 画面ID:SCA1012
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // 調査管理区分
    let hijikaCode = [
      {id: '0', name: '0:非自家用'},
      {id: '1', name: '1:高圧非自家(毎年調査)'},
      {id: '2', name: '2:高圧非自家(隔年調査)'},
      {id: '3', name: '3:低圧自家用'},
      {id: '4', name: '4:調査拒否'},
      {id: '5', name: '5:非自家の取消(自主的に自家用化)'},
      {id: '6', name: '6:非自家の取消(増設50kW以上)'},
      {id: '7', name: '7:非自家の取消(全使撤,低圧化)'},
      {id: '8', name: '8:非自家の取消(その他)'},
    ];
    // 調査業種
    let chousaGyousyuCode = [
      {id: '01', name: '01:ＮＴＴ拒否'},
      {id: '02', name: '02:寝たきり'},
      {id: '03', name: '03:プール'},
      {id: '04', name: '04:浴場'},
      {id: '05', name: '05:学校等'},
      {id: '06', name: '06:老人福祉'},
      {id: '07', name: '07:重要文化財'},
      {id: '08', name: '08:学校でかつプール施設'},
    ];
    // 廃止
    let haisiFlag = [
      {id: '0', name: ''},
      {id: '1', name: '廃止'},
    ];
    // パラメータ取得
    const storage = getSessionObject(GMN.ZENSITETU_INFO.id);
    // TODO フロント画面の判定条件
    let mode = 0;
    let visableSnFlg = true;
    let visableSlFlg = true;
    if (storage['mod'] === 'I') {
      mode = 0;
      visableSnFlg = false;
    } else if (storage['mod'] === 'C') {
      mode = 1;
      visableSnFlg = false;
    } else if (storage['mod'] === 'S') {
      mode = 2;
      visableSnFlg = false;
    } else if (storage['mod'] === 'U') {
      mode = 3;
      visableSnFlg = true;
    } else {
      mode = 4;
      visableSnFlg = false;
    }
    visableSlFlg=storage['hiKetuFlag'];

    this.state = {
      // 1:請求書再請求 2:承認フロー
      mode: mode,
      warningMessages: [],
      // 請求情報
      seikyuInfo: storage ?? {},
      henkoJohomaeList: [],
      seiHeaderDate: {},
      hijikaList: hijikaCode,
      chousaGyousyuList: chousaGyousyuCode,
      haisiList: haisiFlag,
      // 承認機能部表示判定条件
      visableSnFlg: visableSnFlg,
      visableSlFlg: visableSlFlg,
      buttonDisabled: true,
      listZigyojoMst: [],
      modalOpen: false,
      gamenData: {},
      gridRefErr: false,
      rowId: 0,
      showApprovalModal: false,
    };
    // 一覧Ref作成
    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    let initItems = {};
    this.initializeItems(initItems);

    // let seikyuInfo = this.state.seikyuInfo;
    // if (Object.keys(seikyuInfo).length === 0) {
    //   return;
    // }

    // let param = {};
    // if (this.state.mode === 1) {
    //   // 請求一覧から
    //   let paramSeikyu = {
    //     zigyojoCd: seikyuInfo.zigyojoCd,
    //     companyCd: seikyuInfo.companyCd,
    //     kyogaZigyosyaCd: seikyuInfo.kyogaZigyosyaCd,
    //     seikyusakiCd: seikyuInfo.seikyusakiCd,
    //     seikyuTaisyoKikan: seikyuInfo.seikyuTaisyoKikan,
    //     seikyuDate: seikyuInfo.seikyuDate,
    //     seikyuDateRenban: seikyuInfo.seikyuDateRenban,
    //     mode: '1',
    //   };
    //   Object.assign(param, paramSeikyu);
    // } else {
    //   // 承認一覧から
    //   let paramApprove = {
    //     recordId: seikyuInfo.recordId,
    //     mode: '2',
    //   };
    //   Object.assign(param, paramApprove);
    // }

    // // リクエスト出す
    // const response = await postRequest('v1.0/BFE10112G/search', param);

    // if (response.status === HttpStatusCode.Ok) {
    // let data = response.data;
    // if (data['isDataExist'] === false) {
    //   // データなしの場合、メッセージ表示?
    //   this.props.doShowMessage({
    //     message: 'BFY000016E',
    //   });
    // }
    // let henkoJohomaeList = response.data['henkomaeList'];
    let henkoJohomaeList = [];
    let data = {};

    if (this.state.mode !== 0) {
      henkoJohomaeList = [
        {haisiFlag: false, kukakuBango: '00001', supplyPointNo: '01 2345 6789 0123 4567 8901', customerName: '△△△△△△△△△△会社', hijikaCode: '非自家用', chousaGyousyu: 'ＮＴＴ拒否', bikou: '調査理由、コメントする', kukakuBangoHk: '00002', supplyPointNoHk: '02 2345 6789 0123 4567 8901', customerNameHk: '△△△△△△△△△△会社', hijikaCodeHk: '非自家用', chousaGyousyuHk: 'ＮＴＴ拒否'},
        {haisiFlag: false, kukakuBango: '00002', supplyPointNo: '01 2345 6789 0123 4567 8902', customerName: '◇◇◇◇◇◇◇◇◇◇会社', hijikaCode: '非自家用', chousaGyousyu: '寝たきり', bikou: '調査理由、コメントする', kukakuBangoHk: '00003', supplyPointNoHk: '03 2345 6789 0123 4567 8901', customerNameHk: '△△△△△△△△△△会社', hijikaCodeHk: '非自家用', chousaGyousyuHk: 'ＮＴＴ拒否'},
        {haisiFlag: true, kukakuBango: '00004', supplyPointNo: '01 2345 6789 0123 4567 8903', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '低圧自家用', chousaGyousyu: 'プール', bikou: '調査理由、コメントする'},
        {haisiFlag: false, kukakuBango: '00005', supplyPointNo: '01 2345 6789 0123 4567 8904', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '調査拒否', chousaGyousyu: '浴場', bikou: '調査理由、コメントする'},
        {haisiFlag: true, kukakuBango: '00006', supplyPointNo: '01 2345 6789 0123 4567 8905', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(自主的に自家用化)', chousaGyousyu: '学校等', bikou: '調査理由、コメントする'},
        {haisiFlag: true, kukakuBango: '00007', supplyPointNo: '01 2345 6789 0123 4567 8906', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(増設50kW以上)', chousaGyousyu: '老人福祉', bikou: '調査理由、コメントする'},
        {haisiFlag: true, kukakuBango: '00008', supplyPointNo: '01 2345 6789 0123 4567 8907', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(全使撤,低圧化)', chousaGyousyu: '重要文化財', bikou: '調査理由、コメントする'},
        {haisiFlag: false, kukakuBango: '00009', supplyPointNo: '01 2345 6789 0123 4567 8908', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(その他)', chousaGyousyu: '学校でかつプール施設', bikou: '調査理由、コメントする'},
        {haisiFlag: false, kukakuBango: '00010', supplyPointNo: '01 2345 6789 0123 4567 8909', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '非自家の取消(その他)', chousaGyousyu: 'ＮＴＴ拒否', bikou: '調査理由、コメントする'},
        {haisiFlag: false, kukakuBango: '00011', supplyPointNo: '01 2345 6789 0123 4567 8910', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '高圧非自家(毎年調査)', chousaGyousyu: 'プール', bikou: '調査理由、コメントする'},
        {haisiFlag: false, kukakuBango: '00012', supplyPointNo: '01 2345 6789 0123 4567 8911', customerName: '○○○○○○○○○○○○○○○会社', hijikaCode: '高圧非自家(隔年調査)', chousaGyousyu: '重要文化財', bikou: '調査理由、コメントする'},
      ];
      if (this.state.mode === 1) {
        data = {sinseiId: '51602025031401', zigyoujo: '5160', sakuseiDate: '2025/03/14', states: '作成中', userName: '田中　さくら'};
      } else if (this.state.mode === 2) {
        data = {sinseiId: '51602025032101', zigyoujo: '5160', sakuseiDate: '2025/03/21', states: '取止済', userName: '田中　さくら'};
      } else if (this.state.mode === 3) {
        data = {sinseiId: '51602025031801', zigyoujo: '5160', sakuseiDate: '2025/03/18', states: '承認中', userName: '田中　さくら'};
      } else {
        data = {sinseiId: '51602025032001', zigyoujo: '5160', sakuseiDate: '2025/03/20', states: '完了', userName: '田中　さくら'};
      }
    } else {
      data = {sinseiId: '', zigyoujo: '5160', sakuseiDate: '2025-03-28', states: '作成中', userName: '田中　さくら'};
    }

    // 毎年調査お客さま全使撤リスト情報データ設定
    for (const key of Object.keys(initItems)) {
      if (Object.hasOwn(data, key)) {
        initItems[key] = data[key];
      }
    }

    initItems['approvalComment'] = 'approvalComment';

    // 毎年調査お客さま全使撤リストを画面に設定
    this.props.doSetInitValues(initItems);

    if (this.gridRef.current) {
      // 変更前リストデータを画面に設定
      this.gridRef.current.setItemsSource(henkoJohomaeList);
    }

    let listZigyojoMst = [];
    let listMumber1 =
        {id: '1', cd: '5160', cdName: '広島北NWC'};
    listZigyojoMst.push(listMumber1);
    let listMumber2 =
        {id: '2', cd: '6120', cdName: '山口NWC'};
    listZigyojoMst.push(listMumber2);

    this.setState({
      // henkoJohomaeList: henkoJohomaeList,
      seiHeaderDate: data,
      listZigyojoMst: listZigyojoMst,
    });
    // } else {
    //   sysErr(this.props);
    // }
  };

  /**
   * 画面項目初期化
   * @param {object} initItems
   */
  initializeItems = (initItems) => {
    const gmnItems = Object.assign(
        gmnItemsNyuryo,
    );
    for (const key of Object.keys(gmnItems)) {
      const item = gmnItems[key];
      if (Object.hasOwn(item, 'binding')) {
        initItems[item.binding] = null;
      }
    }
  };

  /**
   * コンボリスト作成
   * @param {array} itemsList
   * @param {string} label
   * @param {array} comboList
   */
  setComboList = (itemsList, label, comboList) => {
    const index = this.findIndex(itemsList, label);
    if (index !== -1) {
      itemsList[index].selections = comboList;
    }
  };

  /**
   * 配列検索
   * @param {array} list
   * @param {string} label
   * @return {number} インデックス
   */
  findIndex = (list, label) => {
    return list.findIndex((element) => {
      return element.label === label;
    });
  };

  /**
   * 登録
   */
  doCreate = async () => {
  };

  // /**
  //  * 変更チェック処理
  //  * @param {*} selectedData
  //  * @param {*} beforeData
  //  * @return {*}
  //  */
  // changeCheck(selectedData, beforeData) {
  //   let res = false;
  //   let sameCount = 0;
  //   // 郵便番号
  //   if (selectedData.henkogoSofusakiZipCd ===
  //       beforeData.henkomaeSofusakiZipCd) {
  //     sameCount++;
  //   }
  //   // 住所
  //   if (selectedData.henkogoSofusakiAddress ===
  //       beforeData.henkomaeSofusakiAddress) {
  //     sameCount++;
  //   }
  //   // 都道府県コード
  //   if (selectedData.henkogoSofusakiPrefectures ===
  //       beforeData.henkomaeSofusakiPrefectures) {
  //     sameCount++;
  //   }
  //   // 市区町村コード
  //   if (selectedData.henkogoSofusakiMunicipalities ===
  //       beforeData.henkomaeSofusakiMunicipalities) {
  //     sameCount++;
  //   }
  //   // 大字通称コード
  //   if (selectedData.henkogoSofusakiOazatusyo ===
  //       beforeData.henkomaeSofusakiOazatusyo) {
  //     sameCount++;
  //   }
  //   // 字丁目コード
  //   if (selectedData.henkogoSofusakiAzatyome ===
  //       beforeData.henkomaeSofusakiAzatyome) {
  //     sameCount++;
  //   }
  //   // ビル名等
  //   if (selectedData.henkogoSofusakiBuilding ===
  //       beforeData.henkomaeSofusakiBuilding) {
  //     sameCount++;
  //   }
  //   // 送付先宛名1
  //   if (selectedData.henkogoSofusakiAtena1 ===
  //       beforeData.henkomaeSofusakiAtena1) {
  //     sameCount++;
  //   }
  //   // 送付先宛名2
  //   if (selectedData.henkogoSofusakiAtena2 ===
  //       beforeData.henkomaeSofusakiAtena2) {
  //     sameCount++;
  //   }
  //   // 敬称
  //   if (selectedData.henkogoSofusakiKeisyo ===
  //       beforeData.henkomaeSofusakiKeisyo) {
  //     sameCount++;
  //   }
  //   // 支払方法区分
  //   if (selectedData.henkogoSiharaiHohoCategory ===
  //       beforeData.henkomaeSiharaiHohoCategory) {
  //     sameCount++;
  //   }

  //   // すべて項目一致チェック
  //   if (sameCount === 11) {
  //     res = true;
  //   }
  //   return res;
  // };

  /**
   * 取下げ
   */
  doWithdraw = async () => {
  };

  // /**
  //  * 操作ボタン生成
  //  * @return {*}
  //  */
  // createBtnProps() {
  //   const {handleSubmit} = this.props;

  //   let btnProps = [];
  //   const btnCreate = {type: 'positive', key: 'SCA1012Create', label: '行追加', click: handleSubmit(this.doCreate)};
  //   const btnWithdraw = {type: 'positive', key: 'SCA1012Withdraw', label: '行削除', click: handleSubmit(this.doWithdraw)};

  //   btnProps.push(btnCreate, btnWithdraw);


  //   return btnProps;
  // }

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * 一覧パーツ取得 調査管理区分
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboHijikaList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.hijikaList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.hijikaList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧パーツ取得 調査業種
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboChousaGyousyuList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.chousaGyousyuList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.chousaGyousyuList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };

  /**
   * 一覧パーツ取得 廃止
   * @param {*} view 設定
   * @param {*} readOnly 画面モード
   * @return {*} 一覧パーツ
   */
  getComboHaisiList = (view, readOnly) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      width={view.width}
      dataMap={new DataMap(this.state.haisiList, 'id', 'name')}
      editor={new AutoComplete(document.createElement('div'), {
        itemsSource: this.state.haisiList,
        selectedValuePath: 'id',
        displayMemberPath: 'name',
      })}
      isReadOnly={readOnly}/>;
  };


  /**
   * ロード時、廃止の行はグリーにする
   * @param {*} s
   * @param {*} e
   */
  loadedRowsFunction = (s, e) => {
    for (const row of s.rows) {
      if (row._data.haisiFlag === true) {
        // 対象外の場合、行をグレーにする
        row.cssClass = 'bf-gray-background';
      } else {
        row.cssClass = '';
      }
    }
  };

  /**
   * セル編集終了時の処理
   * @param {*} grid グリッド
   * @param {*} event イベント
   */
  onCellEditEndedFunction = (grid, event) => {
    const binding = event.panel.columns[event.col]?.binding;
    let item = grid.collectionView.items[event.row];
    if (!item) {
      return;
    }
    // 廃止フラグの変更
    if (item && binding === 'haisiFlag') {
      if (item.haisiFlag === true) {
        // 廃止の場合、行をグレーにする
        event.panel.rows[event.row].cssClass = 'bf-gray-background';
      } else {
        event.panel.rows[event.row].cssClass = '';
      }
    }
    grid.refresh();
  };

  /**
   * 変更前一覧描画
   * @return {*}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      id: 'SCA1012HenkomaeTable',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      counterOn: false,
      // style: {height: 'auto', maxHeight: '380px', maxWidth: '100%', width: 'auto', marginTop: '20px'},
      isReadOnly: false,
      screenId: 'SCA1012Henkomae',
      // checkedFunction: this.checkStateUpdate,
      doShowMessage: this.props.doShowMessage,
      validateEdits: true,
      // isDisplayCount: true,
      editPopupItems: this.doAdd,
      // AddDeleteOn: true,
      // getError: this.getError,
      cellEditEndedFunction: this.onCellEditEndedFunction,
      loadedRowsFunction: this.loadedRowsFunction,
    };
    // 一覧定義取得
    let viewElems = [];
    if (henkomaeViews) {
      for (const view of henkomaeViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              // viewGroups.push(this.getViewElemComboBox(elem, false));
              switch (elem.binding) {
                case 'hijikaCode':
                  viewGroups.push(this.getComboHijikaList(elem, false));
                  // viewElem = this.getComboHijikaList(view, false);
                  break;
                case 'chousaGyousyu':
                  viewGroups.push(this.getComboChousaGyousyuList(elem, false));
                  // viewElem = this.getComboChousaGyousyuList(view, false);
                  break;
                // case 'haisiFlag':
                //   viewGroups.push(this.getComboHaisiList(elem, false));
                //   // viewElem = this.getComboHaisiList(view, false);
                //   break;
                default:
                  viewGroups.push(this.getComboHijikaList(elem, false));
                  // viewElem = this.getComboHijikaList(view, false);
              }
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          // viewElem = this.getViewElemComboBox(view, false);
          switch (view.binding) {
            case 'hijikaCode':
              viewElem = this.getComboHijikaList(view, false);
              break;
            case 'chousaGyousyu':
              viewElem = this.getComboChousaGyousyuList(view, false);
              break;
            case 'haisiFlag':
              viewElem = this.getComboHaisiList(view, false);
              break;
            default:
              viewElem = this.getComboHijikaList(view, false);
          }
        } else if (view.dataType === 'cellMaker') {
          viewElem = <FlexGridColumnGroup
            binding={view.binding}
            header={view.header}
            dataType='String'
            width={view.width}
            cellTemplate= {CellMaker.makeButton({
              text: '選択',
              cssClass: 'bf-btn-navy',
              click: (e, ctx) => {
                this.doAdd();
                // this.move('BFY50103G');
              },
            })}/>;
        // } else if (view.dataType === 'checkbox') {
        //   viewElem = <FlexGridColumnGroup
        //     binding={view.binding}
        //     header={view.header}
        //     dataType='String'
        //     width={view.width}
        //     cellTemplate= {CellMaker.makeButton({
        //       text: '引き継ぎ',
        //       cssClass: 'bf-btn-navy',
        //       click: (e, ctx) => {
        //         this.move('BFY50103G');
        //       },
        //     })}/>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }
    // if (henkomaeViews) {
    //   for (const view of henkomaeViews) {
    //     let viewElem;
    //     if (view.type === 'Select') {
    //       switch (view.binding) {
    //         case 'hijikaCode':
    //           viewElem = this.getComboHijikaList(view, false);
    //           break;
    //         case 'chousaGyousyu':
    //           viewElem = this.getComboChousaGyousyuList(view, false);
    //           break;
    //         case 'haisiFlag':
    //           viewElem = this.getComboHaisiList(view, false);
    //           break;
    //         default:
    //           viewElem = this.getComboHijikaList(view, false);
    //       }
    //       // viewElem = this.getViewElemComboBox(view, false);
    //     } else {
    //       viewElem = this.getViewElem(view);
    //     }
    //     viewElems.push(viewElem);
    //   }
    // }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  /**
   * 毎年調査お客さま全使撤リスト画面の入力チェック
   * @param {object} item 検証行データ
   * @param {string} prop binding
   * @param {boolean} parsing 予期されたデータ型に解析できない値を入力したかどうか
   * @return {string} 結果
   */
  getError = (item, prop, parsing) => {
    if (parsing) {
      return null;
    }
    if (prop == 'henkoGo' && item.henkoGo == '') {
      return this.props.getMessage('BFY000017E', ['変更後', item.rowId + '行目']);
    }
    if (prop == 'jikai' && item.jikai == '') {
      return this.props.getMessage('BFY000017E', ['次回', item.rowId + '行目']);
    }
  };

  /**
   * 一覧に変更があるかチェックする
   * @return {bool} true: 変更あり
   */
  doCheckModified = () => {
    let result = false;
    if (this.gridRef.current) {
      result = this.gridRef.current.commitAndCheck();
    }
    return result;
  };

  // /**
  //  * リンクの別タブで画面遷移
  //  * @param  {*} e
  //  */
  // handleLinkClick = (e) => {
  //   e.preventDefault();
  //   const _data = this.state.seikyuInfo;
  //   // BFE10101G_請求一覧に遷移
  //   setSessionObject(
  //       GMN.BFE10101G.id,
  //       this.setParam('', _data),
  //   );
  //   window.open('/BFE10101G', '_blank');
  // };

  /**
   * パラメータ設定
   * @param {*} list パラメータリスト
   * @param {*} data データ
   * @return {*} パラメータ
   */
  setParam = (list, data) =>{
    let _param = {};
    list.forEach((key) => {
      if (Object.hasOwn(data, key)) {
        _param[key] = data[key];
      }
    });
    return _param;
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doSetInitValues(null);
  }

  // /**
  // * ボタンの活性、非活性化
  // */
  // checkStateUpdate = () => {
  //   try {
  //     let bRet = false;

  //     if (this.gridRef && this.gridRef.current &&
  //         this.gridRef.current.selectedItemCount() > 0) {
  //       bRet = true;
  //     }

  //     if (bRet) {
  //       this.setState({buttonDisabled: false});
  //     } else {
  //       this.setState({buttonDisabled: true});
  //     }
  //   } catch (error) {
  //     this.props.doShowMessage({
  //       message: 'TKSCS00001S',
  //       action: () => {
  //         this.props.history.push('/login');
  //       },
  //     });
  //   }
  // };

  /**
   * 削除ボタン押下時
   */
  doDelete = () => {
    let _warningMessages = null;
    try {
      if (!this.gridRef ||
      !this.gridRef.current) {
        return;
      }
      // 未選択チェック
      const count = this.gridRef.current.selectedItemCount();
      if (count === 0) {
        this.props.doShowMessage({
          message: {
            id: 'BFY000023E',
            values: ['削除'],
          },
        });
        return;
      }
      const items = this.gridRef.current.selectedItem();
      let cv = this.gridRef.current.grid.collectionView;
      cv.beginUpdate();
      // 削除
      for (let rowIndex = count - 1; rowIndex >= 0; rowIndex --) {
        let removeIndex = items[rowIndex].index;
        cv.removeAt(removeIndex);
      }
      cv.endUpdate();
    } catch (error) {
      // sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  doInterimSave = () => {
    let values = this.props.values;
    let _warningMessages = [];
    this.setState({
      warningMessages: _warningMessages,
    });

    if (values.sinseiId == '') {
      let message = {
        id: 'BFY000017E',
        values: ['申請番号', ''],
      };
      _warningMessages.push(message);
    }
    if (values.zigyoujo == '') {
      let message = {
        id: 'BFY000017E',
        values: ['NW事業所', ''],
      };
      _warningMessages.push(message);
    }
    if (values.sakuseiDate == '') {
      let message = {
        id: 'BFY000017E',
        values: ['作成日', ''],
      };
      _warningMessages.push(message);
    }

    let tebleData = this.gridRef.current.grid.rows.length;
    for (let i = 0; i < tebleData; i++ ) {
      let a = this.gridRef.current.grid.rows[i].dataItem;
      if (a.henkoGo == '') {
        let message = {
          id: 'BFY000017E',
          values: ['変更後', a.rowId + '行目'],
        };
        _warningMessages.push(message);
      }
      if (a.jikai == '') {
        let message = {
          id: 'BFY000017E',
          values: ['次回', a.rowId + '行目'],
        };
        _warningMessages.push(message);
      }
    }

    if (_warningMessages.length > 0) {
      this.setState({
        warningMessages: _warningMessages,
      });
      return;
    } else {
      this.props.doShowMessage({
        message: {
          id: 'BFY000009I',
          values: ['一時保存'],
        },
      });
    }
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認申請'],
      },
    });
  };

  doFullDelete = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['削除'],
      },
    });
  };

  /**
   * 否認画面の表示
   * @param {string} type
   */
  displayApprovalComment = (type) => {
    this.setState({
      showApprovalCommentModal: true,
      approvalType: type,
    });
  };

  /**
 * 否認画面を閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  doApprove = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認'],
      },
    });
  };

  doRemand = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['差戻'],
      },
    });
  };

  doPrint = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['全使撤リスト出力'],
      },
    });
  };

  /**
   * 追加ボタン押下時
   *
   * @param {object} e
   */
  doAdd = (e) => {
    // let tebleData = this.gridRef.current.grid.rows.length;
    // let list = [];
    // let c = 0;
    // for (let i = 0; i < tebleData; i++ ) {
    //   let a = this.gridRef.current.grid.rows[i].dataItem;
    //   list.push(a);
    //   if (c < parseInt(a.kukakuBango)) {
    //     c = parseInt(a.kukakuBango);
    //   }
    // }
    // let b = {kukakuBango: '000' + (c + 1), henkoMae: '2025', henkoGo: '', zenkai: '○○○○○○○○会社', jikai: '', bikou: ''};
    // list.push(b);
    // this.gridRef.current.setItemsSource(list);

    // console.log(list);

    // this.props.navigate(GMN_PATH.PARCEL_SELECTION);
    // let data = this.props.values;
    // let rowId = e.selectedRows[0].index;
    // this.setState({modalOpen: true, gamenData: data, rowId: rowId});
    this.setState({modalOpen: true});
  };

  doClose = () => {
    // 請求情報データを画面に設定
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({modalOpen: false});
  };

  /**
   * 共通表示内容の取得
   * @param {*} items
   */
  getSelectItems = (items) => {
    let selectItems = items;
    console.log(selectItems);
    let tebleData = this.gridRef.current.grid.rows.length;
    let newDataLength = selectItems.length;
    // let tebleData2 = selectItems.length;
    let list = [];

    let kukakuBangoHk = '';
    let supplyPointNoHk = '';
    let customerNameHk = '';
    let hijikaCodeHk = '';
    let chousaGyousyuHk = '';

    for (let i = 0; i < newDataLength; i++) {
      if (i === 0) {
        kukakuBangoHk = selectItems[i].kukakuBangoHk;
        supplyPointNoHk = selectItems[i].supplyPointNoHk;
        customerNameHk = selectItems[i].customerNameHk;
        hijikaCodeHk = selectItems[i].hijikaCodeHk;
        chousaGyousyuHk = selectItems[i].chousaGyousyuHk;
      } else {
        kukakuBangoHk = kukakuBangoHk+','+selectItems[i].kukakuBangoHk;
        supplyPointNoHk = supplyPointNoHk+','+selectItems[i].supplyPointNoHk;
        customerNameHk = customerNameHk+','+selectItems[i].customerNameHk;
        hijikaCodeHk = hijikaCodeHk+','+selectItems[i].hijikaCodeHk;
        chousaGyousyuHk = chousaGyousyuHk+','+selectItems[i].chousaGyousyuHk;
      }
    }

    for (let i = 0; i < tebleData; i++ ) {
      let a = this.gridRef.current.grid.rows[i];
      if (a.index === this.state.rowId) {
        let c = a.dataItem;
        c['kukakuBangoHk'] = kukakuBangoHk;
        c['supplyPointNoHk'] = supplyPointNoHk;
        c['customerNameHk'] = customerNameHk;
        c['hijikaCodeHk'] = hijikaCodeHk;
        c['chousaGyousyuHk'] = chousaGyousyuHk;
        list.push(c);
      } else {
        let b = a.dataItem;
        list.push(b);
      }
    }
    // for (let i = 0; i < tebleData2; i++ ) {
    //   let b = {kukakuBango: '000' + (c + 1 + i), supplyPointNo: '01 2345 6789 0123 4567 8901', customerName: '追加会社', hijikaCode: '0：非自家用', chousaGyousyu: '05：学校等'};
    //   list.push(b);
    // }
    this.gridRef.current.setItemsSource(list);
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({modalOpen: false});
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {/* <Grid key="key1001Back" item>
          <BackButton props={this.props}/>
        </Grid> */}
        {/* <Grid key="key1001LineAdd" item>
          <PositiveButton
            id="btn1001LineAdd"
            // onClick={handleSubmit(this.doTenNext)}
            onClick={this.doAdd}
            variant="contained"
            startIcon={<AddIcon />}
            // size="large"
          >
            <span>行追加</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001LineDelete" item>
          <DangerButton
            id="btn1001LineDelete"
            // onClick={handleSubmit(this.doTenNext)}
            onClick={this.doDelete}
            variant="contained"
            startIcon={<DeleteIcon />}
            disabled={this.state.buttonDisabled}
            // size="large"
          >
            <span>行削除</span>
          </DangerButton>
        </Grid> */}
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doPrint}
            variant="contained"
            startIcon={<GetAppIcon />}
            // size="large"
          >
            <span>全使撤リスト出力</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doInterimSave}
            variant="contained"
            startIcon={<SaveAltIcon />}
            // size="large"
          >
            <span>一時保存</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen2" item>
          {/* <DangerButton
            id="btn1001CreateTen3"
            onClick={this.doFullDelete}
            variant="contained"
            startIcon={<DeleteIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>削除</span>
          </DangerButton> */}
        </Grid>
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doSyoninShinsei}
            variant="contained"
            startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認申請</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
        {this.state.visableSnFlg &&
        <Grid key="approvalButton" item>
          <PositiveButton
            id="approvalButton"
            onClick={()=> {
              this.displayApprovalComment('1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>}
        {this.state.visableSnFlg &&
        <Grid key="rejectButton" item>
          <DangerButton
            id="rejectButton"
            onClick={()=> {
              this.displayApprovalComment('2');
            }}
            variant="contained"
            startIcon={<Cancel />}
          >
            <span>否決</span>
          </DangerButton>
        </Grid>}
        <Grid key="key1001CreateTen4" item>
          <PositiveButton
            id="btn1001CreateTen4"
            onClick={this.displayApproval}
            variant="contained"
            // startIcon={<SaveIcon />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認状況</span>
            {/* <InfoOutlined fontSize="small"/> */}
          </PositiveButton>
        </Grid>
      </Grid>

    );
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
* 承認状況画面画面を閉じる
*/
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {userInfo} = this.props;
    let itemListNyuryo = createFieldItems(gmnItemsNyuryo);
    let itemListStepApproval = createFieldItems(gmnItemsStepApproval);
    this.setComboList(itemListNyuryo, 'NW事業所', this.state.listZigyojoMst);
    // // ボタン
    // const _btnProps = this.createBtnProps();

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className="form_root">
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          {/* {this.state.visableSnFlg &&
            <Approval props={this.props}
              approve={this.doApprove} sasimodosi={this.doRemand}/>} */}
          <Grid key="keySCA1012Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1012OrderGrid" item xs={12}>
            <PaperPart>
              {createGridFields(GMN.ZENSITETU_INFO.id,
                  itemListNyuryo)}
            </PaperPart>
            {this.state.visableSlFlg &&
            <span>
              <PaperPart>
                <Typography variant="h6" gutterBottom>否決</Typography>
                {createGridFields(GMN.ZENSITETU_INFO.id,
                    itemListStepApproval)}
              </PaperPart>
            </span>
            }
            <div style={{marginBottom: '20px'}} />
            <Divider variant="middle" />
            <div style={{marginBottom: '20px'}} />
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
            >
              <Grid key="keySCA1012HenkomaeTable" item xs={12}>
                {this.renderTable()}
              </Grid>
            </Grid>
          </Grid>

        </MainContainer>
        <CustomerSelect
          modalOpen={this.state.modalOpen}
          selectMode={'radio'}
          closeButton={this.doClose}
          selectButton={this.getSelectItems}></CustomerSelect>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          tstk={false}
          approvalType={this.state.approvalType}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApprovalComment}/>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
      </form>
    );
  }
}

const FORM_NAME = 'SCA1012FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  userInfo: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  title: PropTypes.string,
  genericMap: PropTypes.object,
  getMessage: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withFormatMessage(withMediaQuery()(Container))));
